import { applyMove } from "@dailywars/core/engine";
import type { Move } from "@dailywars/core/engine";

import { interpretEvents } from "#/game/animation/fromEvents";
import type { CanvasBoardAnimation } from "#/game/animation/types";
import type { StoreState } from "#/game/store/types";

export function applyMoveAction({
  state,
  move,
  options,
}: {
  state: StoreState;
  move: Move;
  options?: { suppressMoveAnimation?: boolean };
}): StoreState {
  const beforeState = state.localState;
  const result = applyMove(beforeState, move);
  let anims = interpretEvents({
    beforeState,
    events: result.events,
    afterState: result.state,
  });
  if (options?.suppressMoveAnimation && anims[0]?.type === "move") {
    anims = anims.slice(1);
  }
  const nowMs = typeof performance !== "undefined" ? performance.now() : 0;
  const [firstRaw, ...tailRaw] = anims;
  const animation: CanvasBoardAnimation | null =
    firstRaw !== undefined ? { ...firstRaw, startedAtMs: nowMs } : null;
  const animationQueue: CanvasBoardAnimation[] = tailRaw.map((a) => ({
    ...a,
    startedAtMs: 0,
  }));

  return {
    ...state,
    localState: result.state,
    pendingMoves: [...state.pendingMoves, move],
    selection: { mode: "none" },
    animation,
    animationQueue,
    previewAnimation: null,
  };
}
